import { Observable } from 'rxjs/Observable';
import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { BaseService } from './base.service';
import { Subject } from 'rxjs';
import { IOrg } from 'app/models/IOrg';


@Injectable()
export class OrgService implements OnInit, OnDestroy {


  // public org: Subject<IOrg> = new Subject<IOrg>();
  public org: Subject<IOrg> = new Subject<IOrg>();
  //private state$ = new BehaviorSubject<any>('initialState');
  public orgs: IOrg[];
  constructor(private baseService: BaseService) {

  }

  ngOnDestroy(): void {
    throw new Error("Method not implemented.");
  }
  ngOnInit(): void {
    // this.org.next(this.getOrgs()[0])

  }

  changeOrg(org: IOrg) {
    this.org.next(org);

  }
  getOrg(): Observable<IOrg> {
    return this.org
  }

  getOrgs() {
    return this.baseService.sendHttpGet('/admin/getorgs');

    
  }
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/org.service.ts